module.exports = __webpack_public_path__ + "img/pc_p3_ditu.d92ff1af.svg";